import { render, staticRenderFns } from "./PackageConfirmationModal.vue?vue&type=template&id=04b1917e&scoped=true&"
import script from "./PackageConfirmationModal.vue?vue&type=script&lang=js&"
export * from "./PackageConfirmationModal.vue?vue&type=script&lang=js&"
import style0 from "./PackageConfirmationModal.vue?vue&type=style&index=0&id=04b1917e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "04b1917e",
  null
  
)

export default component.exports